<template>
  <v-form ref="form" flat>
    <div v-for="(answer, index) in answers" :key="index" class="mt-2">
      <v-text-field
        label="Nội dung câu trả lời"
        class="required"
        :rules="[$rules.required]"
        v-model="answer.title"
        dense
        outlined
        required
      ></v-text-field>
    </div>
    <v-btn @click="addAnswer" small depressed> <v-icon left>add</v-icon>Thêm câu trả lời</v-btn>
  </v-form>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
export default {
  props: {
    question: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      answers: []
    }
  },
  methods: {
    getData() {
      return this.answers
    },
    addAnswer() {
      this.answers.push({ id: uuidv4(), title: '' })
    }
  },
  watch: {
    question: {
      handler(val) {
        if (!val || !val.answers.length) return (this.answers = [{ id: uuidv4(), title: '' }])
        if (val) {
          this.answers = val.answers
        }
      },
      immediate: true
    }
  }
}
</script>

<style></style>
